export const EMAIL_TAGS = [
  { label: "Site Link", value: "{{SiteLink}}", description: "Link to the ONEpark website" },
  { label: "Logo", value: "{{Logo}}", description: "Logo image for the ONEpark website" },
  { label: "First Name", value: "{{FirstName}}", description: "First name of the access holder" },
  { label: "Last Name", value: "{{LastName}}", description: "Last name of the access holder" },
  { label: "Account", value: "{{Account}}", description: "Account number for the access holder" },
];
